module.exports = __webpack_public_path__ + "static/Travel_Leisure-4b5c8e9c87e1d9e27de701884b791574.png";